import MenuComponent from '@/components/MenuComponent'
import LoginComponent from '@/pages/Login/Login.vue'
import MenuConnexion from '@/components/MenuConnexion'

export default {
  components: {
    MenuComponent,
    MenuConnexion,
    LoginComponent
  }
}
